import { inject, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventsService } from '@services/events/events.service';
import { PaymentV2Service } from '@services/payment-v2/payment-v2.service';
import { VariablesService } from '@services/variables/variables.service';
import { VwoService } from '@services/vwo/vwo.service';
import { IPaymentConfig } from '@models/payment.model';
import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { ActivatedRoute } from '@angular/router';
import { NgIf, AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CustomTranslatePipe } from '@pipes/translate/translate.pipe';
import { QuickDonateCarouselComponent } from '../../../quicdonate_carousel/quicdonate_carousel.component';
import { DonateBtnComponent } from 'src/app/core/donate-btn/donate-btn.component';
import { BulkDonationSelectionV2Component } from 'src/app/core/bulk-donation-selection-v2/bulk-donation-selection-v2.component';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    CustomTranslatePipe,
    QuickDonateCarouselComponent,
    DonateBtnComponent,
    BulkDonationSelectionV2Component
  ]
})
export class UserInfoComponent {

  public paymentUtil = inject(PaymentUtilService);
  public events = inject(EventsService);
  public vars = inject(VariablesService);
  public vwo = inject(VwoService);
  private actiRoute = inject(ActivatedRoute);
  public paymentV2 = inject(PaymentV2Service);


  @Input() config;
  @Input() user;
  @Input() isLoading;
  @Input() isSipCause;
  @Input() amount;
  @Input() campaignId;
  @Input() currency;
  @Input() isAnonymous;
  @Input() disabled;
  @Input() payment_config: IPaymentConfig;
  @Output() isAnonymousChange = new EventEmitter();
  @Output() onSubmitBulk = new EventEmitter();
  @Output() onBtnClick = new EventEmitter();
  @Output() onEditClick = new EventEmitter();
  params;

  subs: Subscription[] = [];

  ngOnInit() {
    this.setConfig();
    this.params = this.actiRoute.snapshot.queryParams;
  }

  setConfig() {
    this.subs.push(this.paymentUtil.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
      }
    }));
  }

  onClickEdit() {
    this.events.sendSystemEvent({
      eventName: 'edit_donation_form',
      event_type: 'campaign',
      event_type_id: this.vars.fundraiser.id,
    }).subscribe(_ => _);
    this.onEditClick.emit(true);
  }

  onSubmit() {
    this.onBtnClick.emit(true);
  }

  submitBulk = (e) => {
    this.onSubmitBulk.emit(e);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
